export const COLUMN_WIDTH = 170;
export const COLUMN_BG_PADDING = 10;
export const COLUMN_GAP = 60;
